import {HTTP} from './common'

export const LinksApi = {

    get_list(page, size, query) {
        return HTTP.get(`links/?page=${page}&size=${size}&${query?query:''}`).then(response => {
            return response.data
        });
    },
    delete(link_id) {
        return HTTP.delete(`links/${link_id}/`).then(response => {
            return response.data
        });
    },
    review_group_list() {
        return HTTP.get(`links/review_group_list/`).then(response => {
            return response.data
        });
    },
    review_domain_list() {
        return HTTP.get(`links/review_domain_list/`).then(response => {
            return response.data
        });
    },
    review_group_create(data) {
        return HTTP.post(`links/review_group_create/`, data).then(response => {
            return response.data
        });
    },
    save_link(link) {
        return HTTP.post(`links/${link.id}/save_link/`, link).then(response => {
            return response.data
        });
    },
    review_group_delete(data) {
        return HTTP.post(`links/review_group_delete/`, data).then(response => {
            return response.data
        });
    },
    review_group_add(data) {
        return HTTP.post(`links/review_group_add/`, data).then(response => {
            return response.data
        });
    },
    review_group_set(id, data) {
        return HTTP.post(`links/${id}/review_group_set/`, data).then(response => {
            return response.data
        });
    },
    load_file(object) {
        return HTTP.post(`links/load_file/`, object, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data
        })
    },

    request_domain(data) {
        return HTTP.post(`links/request_domain/`, data).then(response => {
            return response.data
        })
    },

};

